/**
 * API URL utility for oly Payroll.
 * On custom domains (e.g., olypayroll.com), always use relative URLs
 * to ensure cookies work correctly (same-origin).
 * On preview/localhost, use the env variable.
 */
function getApiBase() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    // On custom domains, force relative URLs for same-origin cookie handling
    if (
      host !== "localhost" &&
      !host.includes("127.0.0.1") &&
      !host.includes("preview.emergentagent.com")
    ) {
      return "";
    }
  }
  return process.env.REACT_APP_BACKEND_URL || "";
}

export const BACKEND_URL = getApiBase();
export const API = `${BACKEND_URL}/api`;
